import axios from "axios";

// Chamadas do módulo Comandas (backend/api/v1/comandas). Todas com o login do painel.
const API = "/api";
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
const dados = (r) => r.data;

export const comandasApi = {
  listar: (status = "aberta", dia) => axios.get(`${API}/comandas`, { ...auth(), params: { status, ...(dia ? { dia } : {}) } }).then(dados),
  abrir: (body) => axios.post(`${API}/comandas`, body, auth()).then(dados),
  obter: (id) => axios.get(`${API}/comandas/${id}`, auth()).then(dados),
  editar: (id, body) => axios.put(`${API}/comandas/${id}`, body, auth()).then(dados),
  lancar: (id, items, total) => axios.post(`${API}/comandas/${id}/itens`, { items, total }, auth()).then(dados),
  cancelarItem: (id, indice, quantidade, motivo) =>
    axios.post(`${API}/comandas/${id}/itens/cancelar`, { indice, quantidade, motivo }, auth()).then(dados),
  transferir: (id, indice, quantidade, destino_id) =>
    axios.post(`${API}/comandas/${id}/transferir`, { indice, quantidade, destino_id }, auth()).then(dados),
  juntar: (id, origens) => axios.post(`${API}/comandas/${id}/juntar`, { origens }, auth()).then(dados),
  emFechamento: (id, ativo = true) => axios.post(`${API}/comandas/${id}/em-fechamento`, { ativo }, auth()).then(dados),
  fechar: (id, payload) => axios.post(`${API}/comandas/${id}/fechar`, payload, auth()).then(dados),
  cancelar: (id, motivo) => axios.post(`${API}/comandas/${id}/cancelar`, { motivo }, auth()).then(dados),
  // O mesmo campo de cliente das Mesas (nome ou telefone)
  buscarClientes: (termo) => axios.get(`${API}/clientes/search/${encodeURIComponent(termo)}?leve=1&limite=8`, auth()).then(dados),
  imprimePreparo: () => axios.get(`${API}/settings/preparo`, auth()).then(dados).catch(() => null),
  formasDePagamento: () => axios.get(`${API}/payment-methods/module/comandas`, auth()).then(dados),
  cardapio: () => Promise.all([
    axios.get(`${API}/products/for-sale?module=Comandas`, auth()).then(dados),
    axios.get(`${API}/categories`, auth()).then(dados),
    axios.get(`${API}/products`, auth()).then(dados),
    axios.get(`${API}/promotions/active?module=Comandas`).then(dados).catch(() => []),
  ]),
  imprimeFechamento: () => axios.get(`${API}/settings/fechamento`, auth()).then(dados).catch(() => null),
};

export const erroDe = (e, padrao) => e?.response?.data?.detail || e?.message || padrao;
